import styled from "styled-components";

const Style = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 500;
  left: 0;
  top: 0;
  transition: 0.4s opacity;
  animation: .5s forwards fade-in;

  .noti-icon-cont {
    position: absolute;
    background: red;
    width: 64px;
    display: flex;
    justify-content: center;
    padding-left: 16px;
    height: 50px;
    right: 208px;
    top: 7px;
    background: rgb(43, 54, 68);
    border-radius: 2px;

    .notification-icon {
      transform: translateY(-10%);
    }
  }

  &.not-visible {
    opacity: 0;
  }

  @keyframes fade-in {
    0% {opacity: 0;}
    1000% {opacity: 1;}
  }
`

export default Style;
